import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconMemoActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14627_531935)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.78 19.5801L3.37 18.0401C3.16 18.0101 3 17.8301 3 17.6201V4.56006H14.93C15.09 4.56006 15.22 4.69006 15.22 4.85006L15.09 18.4601C15.09 19.1501 14.47 19.6801 13.78 19.5801Z",
				fill: "#333333"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4405 18.4901L16.3005 4.49006L4.37047 4.06006L3.73047 17.5601L16.4405 18.4901Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2217 16.9902V1.7002L4.15172 4.0602L3.51172 17.5602L15.2217 16.9902Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3 17.6302V3.87022C3 3.60022 3.18 3.37022 3.44 3.31022L13.39 1.01022C13.75 0.930223 14.09 1.20022 14.09 1.56022L14.22 15.2502C14.22 15.7502 13.85 16.1802 13.35 16.2502L3 17.6302Z",
				fill: "#333333"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.44141 6.86021V5.55021C5.44141 5.34021 5.59141 5.17021 5.79141 5.13021L11.3214 4.05021C11.5014 4.02021 11.6614 4.15021 11.6614 4.33021V5.64021C11.6614 5.92021 11.4614 6.16021 11.1914 6.20021L5.78141 7.13021C5.61141 7.16021 5.45141 7.03021 5.45141 6.85021H5.44141V6.86021Z",
				fill: "#C0C0C0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14627_531935",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 13.44,
			height: 18.6,
			fill: "white",
			transform: "translate(3 1)"
		})
	}) })]
});
export default SvgIconMemoActive;
